import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

interface FinalizeMysteryConfirmationProps {
    open: boolean;
    onClose: () => void;
    onFinalize: () => void;
}

const FinalizeMysteryConfirmation = (props: FinalizeMysteryConfirmationProps) => {
    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>
                Mystery-Test einreichen
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Möchten Sie den Mystery-Test wirklich einreichen? Die Daten können anschließend nicht mehr
                    bearbeitet werden.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>
                    Abbrechen
                </Button>
                <Button color={'primary'} onClick={props.onFinalize} variant={'contained'}>
                    Einreichen
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FinalizeMysteryConfirmation;
